import { lazy, Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';
import { MantineProvider } from '@mantine/core';
import '@mantine/core/styles.css';
import MainPage from '../pages/main';
import BlogPage from '../pages/blog';
import Terms from '../pages/term';
import Privacy from '../pages/privacy';
import Manual from '../pages/manual';
import AdminApp from '../admin';
import ShopApp from '../shop';

const PortalPage = lazy(() => import('../portal/PortalPage'));

export function App() {
  return (
    <Routes>
      <Route path="/" element={<MainPage />} />
      <Route path="/blog/:id" element={<BlogPage />} />
      <Route path="/term" element={<Terms />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/manual" element={<Manual />} />
      <Route path="/admin/*" element={<AdminApp />} />
      <Route path="/shop/*" element={<ShopApp />} />
      <Route path="/portal/:conversationId" element={
        <MantineProvider defaultColorScheme="light">
          <Suspense fallback={<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>Loading...</div>}>
            <PortalPage />
          </Suspense>
        </MantineProvider>
      } />
    </Routes>
  );
}

export default App;
